const FURYPAGE_COLOR = '#30FF83';
const TEXT_COLOR = '#000000';

export class Ad {

    parentStyle = {
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: '0px',
        left: '0px',
        background: `${FURYPAGE_COLOR}66`,
    }

    contStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        padding: '20px',
        'max-width': '400px',
        display: 'flex',
        gap: '10px',
        'flex-direction': 'column',
        'align-items': 'center',
        'text-decoration': 'none',
        background: `${FURYPAGE_COLOR}`,
        //border: '4mm ridge '+ FURYPAGE_COLOR,
        'box-shadow': `${TEXT_COLOR}AA 10px 10px, ${TEXT_COLOR}77 20px 20px, ${TEXT_COLOR}44 30px 30px, ${TEXT_COLOR}22 40px 40px`,
        border: '10px solid '+ TEXT_COLOR
        // bottom: '0px',
    }

    videoStyle = {
        height: 'auto',
        width: '100%',
        'min-width': '250px',
    }

    textStyle = {
        'font-size': '20px',
        'font-weight': '800',
        color: TEXT_COLOR,
        'font-family': 'Arial, sans-serif',
        outline: '0',
    }

    adContainer: HTMLElement;

    constructor() {
        const { body } = document;
        // PARENT
        const parent = document.createElement('div');
        this.adContainer = parent;
        this.setStyle(parent, this.parentStyle);
        body.appendChild(parent);
        parent.addEventListener('click', () => {
            this.hide();
        });

        // CONTAINER
        const cont = document.createElement('a');
        cont.href = 'https://furypage.com/?ref=supernovae';
        cont.target = '_blank';
        this.setStyle(cont, this.contStyle);
        parent.appendChild(cont);

        // VIDEO
        const video = document.createElement('video');
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.src = 'https://furypage.com/product_video.mp4';
        this.setStyle(video, this.videoStyle);
        cont.appendChild(video);

        // TEXT
        const text = document.createElement('div');
        text.textContent = 'DISCOVER FURYPAGE: DESIGN YOUR 3D INTERACTIVE PORTFOLIO ==>'
        this.setStyle(text, this.textStyle);
        cont.appendChild(text);

        this.hide();
    }

    show() {
        this.adContainer.style.display = 'flex';
    }

    hide() {
        this.adContainer.style.display = 'none';
    }

    setStyle(el: HTMLElement, style) {
        for (const key in style) {
            el.style[key] = style[key];
        }
    }
}
